export const ANCHOR_TAG = 'a';
export const ARTICLE_SEARCH = 'article search';
export const FIELD_NAME = 'query';
export const THREAD_ID = 'threadID';
export const SUGGESTED_PROMPT_QUERY_PARAM = 'suggestedPrompt';

export enum Pages {
  Chatbot = 'chatbot',
  Welcome = 'welcome',
}
